import React, { useState } from 'react'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import { BiPlug } from 'react-icons/bi'
import PayhelmLogo from '../../../assets/images/payhelm-logo-blue.png'
import { selectRootUser } from '../../../rootSlice'
import { createUserAPIKey } from '../../Settings/settingsSlice'
import ConfirmModal from '../../Settings/views/APIKey/ConfirmModal'
import CopyToClipboardButton from '../../../features/buttons/CopyToClipboardButton'

const logoClassName = 'tw-max-w-full tw-max-h-full'

export default function PayhelmAPIKeyCard() {
  const dispatch = useDispatch()
  const user = useSelector(selectRootUser)
  const [apiKey, setApiKey] = useState(null)
  const [confirmModalVisible, setConfirmModalVisible] = useState(false)

  const generateAPIKey = async () => {
    const { payload: newApiKey } = await dispatch(createUserAPIKey({ unique_user_id: user.id }))
    setApiKey(newApiKey)
  }

  const handleGenerateAPIKey = async () => {
    if (user?.api_key) {
      setConfirmModalVisible(true)
      return
    }

    generateAPIKey()
  }

  return (
    <>
      <div className="tw-col-span-1">
        <div className="tw-h-[240px] tw-flex tw-flex-col tw-rounded-lg tw-shadow-md tw-p-4 tw-bg-white hover:tw-ring hover:tw-ring-blue-600">
        <div className="tw-flex tw-items-center tw-justify-between tw-mb-6 tw-shrink-0">
          <div className="tw-w-24 tw-h-12 tw-flex tw-items-center tw-justify-start">
            <img src={PayhelmLogo} className={logoClassName} alt="PayHelm logo" />
          </div>
          {!apiKey && (
            <button
              type="button"
              className="tw-text-sm tw-cursor-pointer tw-rounded-md tw-border tw-border-slate-300 hover:tw-border-blue-600 hover:tw-bg-blue-600 hover:tw-text-white tw-transition-colors tw-duration-150 tw-shadow-sm tw-flex tw-items-center tw-space-x-2.5 tw-px-2.5 tw-py-1"
              onClick={handleGenerateAPIKey}
            >
              <BiPlug />
              <span>{user?.api_key ? 'Re-generate API Key' : 'Generate API Key'}</span>
            </button>
          )}
        </div>
        <div className="tw-flex tw-flex-col tw-min-h-0 tw-flex-1">
          <div className="tw-text-base tw-font-bold tw-mb-2 tw-shrink-0">Payhelm API Key</div>
          <div className="tw-text-slate-500 tw-text-sm tw-mb-3">
            {user?.api_key ? 'Generating a new key will replace your current key.' : 'Create an API key to gain access to our API.'}
          </div>
          <div className="tw-min-h-0 tw-flex-1 tw-text-sm tw-text-slate-500">
            {apiKey ? (
              <div>
                <div className="tw-text-red-500 tw-mb-2 tw-text-xs">
                  Please store this key safely somewhere - you won't be able to see it again.
                </div>
                <div className="tw-p-3 tw-rounded-xl tw-bg-slate-100 tw-flex tw-items-center tw-space-x-2">
                  <CopyToClipboardButton value={apiKey} />
                  <div className="tw-text-xs tw-truncate">{apiKey}</div>
                </div>
              </div>
            ) : (
              user?.api_key_create_time && (
                <div className="tw-p-3 tw-rounded-xl tw-bg-slate-100 tw-text-slate-600">
                  API key last generated on: {moment(user.api_key_create_time).format('MMM DD, YYYY (h:MM A)')}
                </div>
              )
            )}
          </div>
        </div>
      </div>
      </div>

      <ConfirmModal
        visible={confirmModalVisible}
        closeModal={() => setConfirmModalVisible(false)}
        generateAPIKey={generateAPIKey}
      />
    </>
  )
}
